// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bolt-panel-footer-buttons {\r\n    flex-wrap: wrap;\r\n}", "",{"version":3,"sources":["webpack://./src/Docs/Components/Dialog/examples/Dialog.Example.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB","sourcesContent":[".bolt-panel-footer-buttons {\r\n    flex-wrap: wrap;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
